<template>
  <div id="state_dialog">
    <div class="content">
      <!-- <div class="dialog-title">{{ dialogData.title }}</div>
      <div class="verification">
        <div class="verification_outer">
          <div class="ver3"></div>
          <div class="ver1">
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
            <div class="ver1_center"></div>
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
          </div>
          <div class="ver2">
            <span>验证身份</span>
            <span>重置密码</span>
          </div>
        </div>
      </div> -->
      <div class="top">
        <div class="topTitle">{{ dialogData.title }}</div>
        <div class="box">
          <div class="one">
            <div class="oneo"></div>
          </div>
          <div class="two"></div>
          <div class="three">
            <div class="oneo"></div>
          </div>
        </div>
        <div class="state">
          <span>验证身份</span>
          <span>重置密码</span>
        </div>
      </div>
      <div class="stateBox">
        <img class="one" src="../../assets/img/shtg.png" alt="" />
        <div class="two">{{ dialogData.stateInfo }}</div>
        <div class="three" @click="returnLogin">
          {{ dialogData.statebtnName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "state_dialog",
  props: {
    myDialogData: {
      type: Object,
      default: function () {
        return {
          flag: true,
          title: "注册",
          data: [],
          stateNameOne: "验证身份",
          stateNameTwo: "重置密码",
        };
      },
    },
  },
  data() {
    return {
      dialogData: this.myDialogData,
    };
  },
  methods: {
    returnLogin() {
      this.$router.push("/");
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#state_dialog {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    width: 36.1875rem;
    height: 99.5%;
    box-sizing: border-box;
    padding-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 10px 0 10px;
    .dialog-title {
      font-size: 14px;
      margin-bottom: 30px;
    }
    .top {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      border-bottom: 1px solid rgba(245, 245, 245, 1);
      .topTitle {
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 14px;
        margin-bottom: 25px;
      }
      .box {
        width: 90%;
        display: flex;
        align-items: center;
        .one {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: rgba(152, 188, 255, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          .oneo {
            width: 9px;
            height: 9px;
            border-radius: 50%;
            background: rgba(51, 125, 255, 1);
          }
        }
        .two {
          flex: 1;
          height: 8px;
          background: rgba(224, 241, 255, 1);
        }
        .three {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: rgba(152, 188, 255, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          .oneo {
            width: 9px;
            height: 9px;
            border-radius: 50%;
            background: rgba(51, 125, 255, 1);
          }
        }
      }
      .state {
        width: 100%;
        margin: 16px 0;
        display: flex;
        justify-content: space-between;
        > span {
          font-size: 14px;
        }
      }
    }

    .stateBox {
      width: 258px;
      height: 182px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .one {
        width: 70px;
        height: 70px;
      }
      .two {
        font-size: 15px;
        font-weight: 500;
      }
      .three {
        width: 132px;
        height: 32px;
        border-radius: 5px;
        background: rgba(31, 97, 150, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
    }
  }
}
</style>
